import React, { useEffect } from 'react'
import useTranslation from 'next-translate/useTranslation'
import useSocket from 'tennders-common/hooks/useSocket'
import useTransactionLog from 'tennders-transactions/hooks/useTransactionLog'
import { REFRESH_TYPES } from 'tennders-common/stores/socket/action'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import LoadHistory from './LoadHistory'

type Props = {
  id ?: string,
  isSingleView ?: boolean
  shouldShowCommentsOnly ?: boolean
}

export const HistoryLoads = React.memo(({ id, isSingleView, shouldShowCommentsOnly } : Props) => {
  const { t } = useTranslation()
  const { logs, fetchLoadHistory, nomore } = useTransactionLog('loads', shouldShowCommentsOnly)
  const { refresh } = useSocket()
  const { transaction } = useTransaction()

  useEffect(() => {
    if (refresh === `${REFRESH_TYPES.TLOG_LOAD}-${id}`) {
      fetchLoadHistory(id, true)
    }
  }, [refresh])

  return (
    logs.length === 0 && !transaction?.id
      ? <div className="text-center">{t('transactionHistory:no_logs_yet')}</div>
      : (
        <LoadHistory
          more={!nomore}
          loading={false}
          loadMore={() => fetchLoadHistory(id)}
          isSingleView={isSingleView}
          logs={logs}
        />
      )
  )
})
